import { computed } from 'vue';
import { appConfig, isE2eMode } from '../providers/config';

const HUBSPOT_FORM_REGION = 'eu1';

const ensureFormScript = (portalId: string) => {
  const scriptId = `hs-form-embed-${portalId}`;

  if (document.getElementById(scriptId)) {
    return;
  }

  const script = document.createElement('script');
  script.id = scriptId;
  script.defer = true;
  script.src = `https://js-${HUBSPOT_FORM_REGION}.hsforms.net/forms/embed/${portalId}.js`;
  document.head.appendChild(script);
};

export const useHubspotForm = () => {
  const portalId = isE2eMode ? undefined : appConfig.VITE_HUBSPOT_HUB_ID;
  const formId = isE2eMode ? undefined : appConfig.VITE_HUBSPOT_PREORDER_FORM_ID;

  const isFormAvailable = computed(() => !!portalId && !!formId);

  const loadForm = () => {
    if (!portalId || !formId) {
      return;
    }

    ensureFormScript(portalId);
  };

  return {
    isFormAvailable,
    loadForm,
    portalId,
    formId,
    region: HUBSPOT_FORM_REGION,
  };
};
